﻿import InitCart from '../store/cart';
import disableScroll from 'disable-scroll';
class Megamenu {
  constructor() {
    this.props = {
      megamenu: document.querySelector('.megamenu'),
      menubutton: document.querySelector('.js-menu'),
      navs: document.querySelectorAll('.megamenu__nav'),
      currentActive: document.querySelector('.megamenu__nav--active')
    };
    this.bind();

    this.closeMenu = this.closeMenu.bind(this);

  }

  bind() {
    const { menubutton, navs,megamenu } = this.props;

    if (menubutton) {
      const cartPreview = document.querySelector('.cartpreview');
      const openDropdownButtons = document.querySelectorAll('.js-megamenu-dropdown');
      const closeDropdownButtons = document.querySelectorAll('.js-dropdown-close');
      const timetable = document.querySelector('.header__buttonTimetable');
      const search = document.querySelector('.header__buttonSearch');
      const mypages = document.querySelector('.header__buttonMypages');
      const pricePage = document.querySelector('.header__buttonPrice');
      const cart = document.querySelector('.header__buttonCart');
      const dots = menubutton.querySelector('.hamburger');
      const headerActions = document.querySelector('.header__actions');
      const wrapper = document.getElementsByClassName('wrapper')[0];
      const footer = document.getElementsByTagName('footer')[0];
      menubutton.addEventListener('click', e => {
        if (cartPreview.classList.contains('cartpreview--show')) {
          InitCart.closeCartPreview();
        }
        else if (megamenu.classList.contains('megamenu--active')) {
          megamenu.classList.remove('megamenu--active');
          document.body.classList.remove('disable-scroll');
          headerActions.classList.remove('header__menu--active');
          timetable.classList.remove('header__button--active');
          search.classList.remove('header__button--active');
          mypages.classList.remove('header__button--active');
          pricePage.classList.remove('header__button--active');
          cart.classList.remove('header__button--active');
          dots.classList.remove('hamburger-is-active');
          disableScroll.off();
        } else {
          megamenu.classList.add('megamenu--active');
          document.body.classList.add('disable-scroll');
          headerActions.classList.add('header__menu--active');
          timetable.classList.add('header__button--active');
          search.classList.add('header__button--active');
          mypages.classList.add('header__button--active');
          pricePage.classList.add('header__button--active');
          cart.classList.add('header__button--active');
          dots.classList.add('hamburger-is-active');
        };
    
        this.updateButtonText();
      });

      if (openDropdownButtons) {
  
        Array.prototype.forEach.call(openDropdownButtons, (button) => {
          button.addEventListener('click', (e) => {
            const nav = e.target.parentElement.parentElement.parentElement;
            e.stopImmediatePropagation();
            this.openDropdown(nav);
            e.stopImmediatePropagation();
          })
        })
  
      }
      if (closeDropdownButtons) {
  
        Array.prototype.forEach.call(closeDropdownButtons, (button) => {
  
          button.addEventListener('click', (e) => {
            const nav = e.target.parentElement;
            e.stopImmediatePropagation();
            this.closeDropdown(nav);
            e.stopImmediatePropagation();
          });
  
        });
  
      }
    }

    if (megamenu) {
      megamenu.addEventListener('click', e => {
        const megamenuMatches = e.target.matches ? e.target.matches('.megamenu') : e.target.msMatchesSelector('.megamenu');
        if(megamenuMatches) {
          const dots = menubutton.querySelector('.hamburger');
          megamenu.classList.remove('megamenu--active');
          document.body.classList.remove('disable-scroll');
          dots.classList.remove('hamburger-is-active');
          disableScroll.off();
          this.updateButtonText();
        }
      });
    }
  }

  closeMenu() {
    const { menubutton, megamenu } = this.props;
    const dots = menubutton.querySelector('.hamburger');
    const timetable = document.querySelector('.header__buttonTimetable');
    const mypages = document.querySelector('.header__buttonMypages');
    const pricePage = document.querySelector('.header__buttonPrice');
    const cart = document.querySelector('.header__buttonCart');
    megamenu.classList.remove('megamenu--active');
    document.body.classList.remove('disable-scroll');
    disableScroll.off();
    dots.classList.remove('hamburger-is-active');
    timetable.classList.toggle('header__button--active');
    mypages.classList.toggle('header__button--active');
    pricePage.classList.toggle('header__button--active');
    cart.classList.toggle('header__button--active');
    this.updateButtonText();
    disableScroll.off();
  }

  updateButtonText() {
    const textEl = document.querySelector('.button__text');
    const text = textEl.getAttribute('data-text');
    const currentText = textEl.innerText;

    textEl.setAttribute('data-text', currentText);
    textEl.innerText = text;
  }
  
  toggleMenu() {
    const { megamenu, menubutton } = this.props;
    const timetable = document.querySelector('.header__buttonTimetable');
    const search = document.querySelector('.header__buttonSearch');
    const mypages = document.querySelector('.header__buttonMypages');
    const pricePage = document.querySelector('.header__buttonPrice');
    const cart = document.querySelector('.header__buttonCart');
    const headerActions = document.querySelector('.header__actions');
    const wrapper = document.querySelector('.wrapper');
    const footer = document.querySelector('footer')

    
          
    if (megamenu.classList.contains('megamenu--active')) {
      megamenu.classList.remove('megamenu--active');
      document.body.classList.remove('disable-scroll');
      headerActions.classList.remove('header__menu--active');
      timetable.classList.remove('header__button--active');
      search.classList.remove('header__button--active');
      mypages.classList.remove('header__button--active');
      pricePage.classList.remove('header__button--active');
      cart.classList.remove('header__button--active');
      dots.classList.remove('hamburger-is-active');
      disableScroll.off();
    } else {
      megamenu.classList.add('megamenu--active');
      document.body.classList.add('disable-scroll');
      headerActions.classList.add('header__menu--active');
      timetable.classList.add('header__button--active');
      search.classList.add('header__button--active');
      mypages.classList.add('header__button--active');
      pricePage.classList.add('header__button--active');
      cart.classList.add('header__button--active');
      dots.classList.add('hamburger-is-active');
    };

    this.updateButtonText();
  }

  openDropdown(currentNav) {
    const { navs, megamenu } = this.props;

    if (!currentNav.classList.contains("megamenu__nav--active")) {

      Array.prototype.forEach.call(navs, (nav, index) => {
        nav.classList.remove('megamenu__nav--hide');
        nav.classList.remove('hide');
        nav.classList.remove('megamenu__nav--show');
        nav.classList.add('megamenu__nav--hide');
      })

      currentNav.addEventListener("webkitAnimationEnd", openAnimationHandler);
      currentNav.addEventListener("oAnimationEnd", openAnimationHandler);
      currentNav.addEventListener("msAnimationEnd", openAnimationHandler);
      currentNav.addEventListener("webkitAnimationEnd", openAnimationHandler);

      function openAnimationHandler() {
        megamenu.querySelector('.megamenu__content').scrollTop = 0;
        Array.prototype.forEach.call(navs, (nav, index) => {
          if (nav !== currentNav) {
            nav.classList.remove('hide');
            nav.classList.add('hide');
          }
        });
        if (!currentNav.classList.contains('megamenu__nav--active')) {
          currentNav.classList.remove('megamenu__nav--show');
          currentNav.classList.remove('megamenu__nav--hide');
          currentNav.classList.remove('hide');
          currentNav.classList.add('megamenu__nav--active');
        }
        currentNav.removeEventListener("webkitAnimationEnd", openAnimationHandler);
        currentNav.removeEventListener("oAnimationEnd", openAnimationHandler);
        currentNav.removeEventListener("msAnimationEnd", openAnimationHandler);
        currentNav.removeEventListener("animationend", openAnimationHandler);
      }

    } else {
      this.closeDropdown(currentNav);
    }
  }

  closeDropdown(currentNav) {
    const { navs, megamenu } = this.props;
    currentNav.classList.add('megamenu__nav--close');

    currentNav.addEventListener("webkitAnimationEnd", closeAnimationHandler);
    currentNav.addEventListener("oAnimationEnd", closeAnimationHandler);
    currentNav.addEventListener("msAnimationEnd", closeAnimationHandler);
    currentNav.addEventListener("animationend", closeAnimationHandler);

    function closeAnimationHandler() {
      megamenu.querySelector('.megamenu__content').scrollTop;
      currentNav.classList.remove('megamenu__nav--close');
      currentNav.classList.remove('megamenu__nav--active');
      currentNav.classList.add('megamenu__nav--show');

      Array.prototype.forEach.call(navs, (nav, index) => {
        if (nav !== currentNav) {
          nav.classList.remove('megamenu__nav--hide');
          nav.classList.remove('hide');
          nav.classList.add('megamenu__nav--show');
        };
      });

      currentNav.removeEventListener("webkitAnimationEnd", closeAnimationHandler);
      currentNav.removeEventListener("oAnimationEnd", closeAnimationHandler);
      currentNav.removeEventListener("msAnimationEnd", closeAnimationHandler);
      currentNav.removeEventListener("animationend", closeAnimationHandler);
    };
  }
}

const Menu = new Megamenu();

export default Menu;

